import { useClipboard, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";

const useCopy = (initialValue: string) => {
  const toast = useToast();
  const [initial, setInitial] = useState(initialValue);
  const { hasCopied, onCopy, value, } = useClipboard(initial);

  const updateIntialValue = (update: string) => {
    navigator.clipboard.writeText(update);
    setInitial(update);
  };

  useEffect(() => {
    if (hasCopied)
      toast({
        title: "Copied!! 🥳🎉🤝",
        status: "success",
        duration: 4000,
        isClosable: true,
      });
  }, [hasCopied, toast]);

  return { onCopy, value, updateIntialValue };
};

export default useCopy;
